import saw from '../lib/ScormApiWrapper';

export default class ScormAPI {
  constructor() {
    this._saw = saw;

    this._actions = {
      initialize: (payload) => this._initialize(payload),
      commit: (payload) => this._commit(payload),
      finish: (payload) => this._finish(payload),
      'save-state': (payload) => this._saveState(payload),
      'is-initialized': (payload) => this._isInitialized(payload),
      'get-launch-data': (payload) => this._getLaunchData(payload),
      'get-learner-id': (payload) => this._getLearnerId(payload),
      'get-learner-name': (payload) => this._getLearnerName(payload),
      'get-lesson-location': (payload) => this._getLessonLocation(payload),
      'get-lesson-status': (payload) => this._getLessonStatus(payload),
      'get-saved-state': (payload) => this._getSavedState(payload),
      'get-score': (payload) => this._getScore(payload),
      'get-student-name': (payload) => this._getStudentName(payload),
      'get-student-id': (payload) => this._getStudentId(payload),
      'get-mastery-score': (payload) => this._getMasteryScore(payload),
      'set-session-time': (payload) => this._setSessionTime(payload),
      'set-lesson-location': (payload) => this._setLessonLocation(payload),
      'set-lesson-status': (payload) => this._setLessonStatus(payload),
      'set-min-score': (payload) => this._setMinScore(payload),
      'set-max-score': (payload) => this._setMaxScore(payload),
      'set-score': (payload) => this._setScore(payload),
    };
  }

  do(action, payload) {
    return this._actions[action](payload);
  }

  setMode(mode) {
    this.mode = mode;
  }

  setOldScore(score) {
    if (score && score > -1) {
      this.oldScore = score;
    } else {
      this.oldScore = -1;
    }
  }

  _initialize() {
    // @TODO: re-think scorm communication
    try {
      this._saw.initialize();
    } catch (e) {
      // 1. Find API object and configure _saw
      this._saw.configure();

      // 2. Close any previous session
      this._saw.API.LMSFinish('');

      // 3. Initialize new session
      this._saw.initialize();
    }

    return {};
  }

  _commit() {
    this._saw.commit();
    return {};
  }

  _finish() {
    this._saw.finish();
    return {};
  }

  _saveState(payload) {
    this._saw.setScormValue('cmi.suspend_data', payload.data);
    return {};
  }

  _isInitialized() {
    return {
      data: this._saw.isInitialized(),
    };
  }

  _getLaunchData() {
    return {
      data: this._saw.getScormValue('cmi.launch_data'),
    };
  }

  _getLearnerId() {
    return {
      data: this._saw.getScormValue('cmi.core.student_id'),
    };
  }

  _getLearnerName() {
    return {
      data: this._saw.getScormValue('cmi.core.student_name'),
    };
  }

  _getLessonLocation() {
    return {
      data: this._saw.getScormValue('cmi.core.lesson_location'),
    };
  }

  _getLessonStatus() {
    return {
      data: this._saw.getScormValue('cmi.core.lesson_status').toLowerCase(),
    };
  }

  _getSavedState() {
    return {
      data: this._saw.getScormValue('cmi.suspend_data'),
    };
  }

  _getScore() {
    return {
      data: this._saw.getScormValue('cmi.core.score.raw'),
    };
  }

  _getStudentName() {
    return {
      data: this._saw.getScormValue('cmi.core.student_name'),
    };
  }

  _getStudentId() {
    return {
      data: this._saw.getScormValue('cmi.core.student_id'),
    };
  }

  _getMasteryScore() {
    const score = parseInt(
      this._saw.getScormValue('cmi.student_data.mastery_score')
    );

    if (isNaN(score)) {
      return {data: 85};
    }

    return {data: score};
  }

  _setSessionTime(payload) {
    this._saw.setScormValue('cmi.core.session_time', payload.data);
    return {};
  }

  _setLessonLocation(payload) {
    this._saw.setScormValue('cmi.core.lesson_location', payload.data);
    return {};
  }

  _setLessonStatus(payload) {
    this._saw.setScormValue(
      'cmi.core.lesson_status',
      payload.data.toLowerCase()
    );
    return {};
  }

  _setMinScore(payload) {
    this._saw.setScormValue('cmi.core.score.min', payload.data);
    return {};
  }

  _setMaxScore(payload) {
    this._saw.setScormValue('cmi.core.score.max', payload.data);
    return {};
  }

  _setScore(payload) {
    this._saw.setScormValue('cmi.core.score.raw', payload.data);
    return {};
  }
}
